module.exports = __webpack_public_path__ + "static/media/404.8f0cff5d.svg";